import { render, staticRenderFns } from "./ModalMainScreen.vue?vue&type=template&id=3e566778&scoped=true"
import script from "./ModalMainScreen.vue?vue&type=script&lang=js"
export * from "./ModalMainScreen.vue?vue&type=script&lang=js"
import style0 from "./ModalMainScreen.vue?vue&type=style&index=0&id=3e566778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e566778",
  null
  
)

export default component.exports